export const getDurationLabel = (duration: number) => {
  if (duration === 0) {
    return 'None';
  }

  return `${duration} ${duration === 1 ? 'year' : 'years'}`;
};
